<template>
  <section>
    <el-container>
      <el-header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>充电监控</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <el-container>
        <el-aside class="tree-aside" style="max-width: 240px;min-width: 240px; width: auto">
          <el-input size="small"
                    placeholder="请输入充电站关键字"
                    v-model="stationNameIpt">
          </el-input>
          <el-tree
            class="station-tree"
            :data="stationTree"
            :props="defaultProps"
            highlight-current
            default-expand-all
            :filter-node-method="filterNode"
            @node-click="nodeClick"
            ref="tree">
            <div :style="{color: data.node.isCurrent && data.node.isLeaf?'#1cbbb4':'#333333'}" slot-scope="data">
              <!--{{data.node.level}},{{data.node.isLeaf}},{{data.node.isCurrent}} ,{{data.data.label}}-->
              <template v-if="data.node.level == 1">
                <el-image src="static/image/province.png" class="box-image"></el-image>
              </template>
              <template v-if="data.node.level == 2">
                <el-image src="static/image/city3.png" class="box-image"></el-image>
              </template>
              <template v-if="data.node.level == 3">
                <el-image src="static/image/charge2.png" class="box-image"></el-image>
              </template>
              {{ellipsis(data.data.label, 15)}}
            </div>
          </el-tree>
        </el-aside>
        <el-container>
          <el-main class="has-no-paddingtop">
            <el-row>
              <a href="javascript:void(0);">
                <el-tag size="small"
                        v-for="item in items"
                        :key="item.label"
                        :style="{color: tagSelected(item.name)?item.bgColor:item.color, backgroundColor: tagSelected(item.name)?item.color:item.bgColor, borderColor: item.bgColor}"
                        @click="switchTag(item.name)"
                >
                  {{ item.label}}{{item.value}}
                </el-tag>
              </a>
            </el-row>
            <div class="all-port-div">
              <template v-for="(gun, index) in tarGuns">
                <div class="port-div" :key="index" v-if="showGun(gun.status.value)">
                  <el-card class="box-card">
                    <!--{{gun.pileName}} /-->
                    <el-tag
                      :style="{color: items[gun.status.value].color, backgroundColor: items[gun.status.value].bgColor, borderColor: items[gun.status.value].bgColor}">
                      <template v-if="gun.gunCode">
                        {{gun.gunCode}} /
                      </template>
                      <template v-if="gun.gunNumber">
                        {{gun.gunNumber}}号 /
                      </template>
                      {{gun.status.message}}
                    </el-tag>
                    <!--<el-tag>{{gun.gunNumber}} / {{gun.status.message}}</el-tag>-->
                    <el-card class="box">
                      <!--<template v-if="gun.status.value == 'charging'">-->
                      <el-row>
                        <el-tooltip class="item" effect="dark" content="电量" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/dianliang.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.totalPower}} kw·h</div>
                          </el-col>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="SOC" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/baifenbi.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.soc}} %</div>
                          </el-col>
                        </el-tooltip>
                      </el-row>
                      <el-row>
                        <el-tooltip class="item" effect="dark" content="电压" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/dianya.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.voltage}} V</div>
                          </el-col>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="电流" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/dianliu.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.current}} A</div>
                          </el-col>
                        </el-tooltip>
                      </el-row>
                      <el-row>
                        <el-tooltip class="item" effect="dark" content="功率" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/gonglv.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.power}} kw</div>
                          </el-col>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="温度" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/wendu.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.temperature}}℃</div>
                          </el-col>
                        </el-tooltip>
                      </el-row>
                      <el-row>
                        <el-tooltip class="item" effect="dark" content="启动方式" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/ka.png" class="box-image"></el-image>
                            <div class="box-div">{{startType(gun.startWay)}}</div>
                          </el-col>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="交直流" placement="top-start">
                          <el-col :span="12">
                            <el-image src="static/image/jiaozhiliu.png" class="box-image"></el-image>
                            <div class="box-div">{{gunType(gun.gunType)}}</div>
                          </el-col>
                        </el-tooltip>
                      </el-row>
                      <!--</template>-->
                      <el-row>
                        <el-tooltip class="item" v-if="gun.startWay && gun.startWay == '1'" effect="dark" content="手机号码" placement="top-start">
                          <el-col :span="24">
                            <el-image src="static/image/number.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.phone}}</div>
                          </el-col>
                        </el-tooltip>
                        <el-tooltip class="item" v-if="gun.startWay && gun.startWay == '0'" effect="dark" content="卡号" placement="top-start">
                          <el-col :span="24">
                            <el-image src="static/image/number.png" class="box-image"></el-image>
                            <div class="box-div">{{gun.cardNumber}}</div>
                          </el-col>
                        </el-tooltip>
                        <!--<el-tooltip class="item" effect="dark" content="运行天数" placement="top-start">-->
                        <!--<el-col :span="12">-->
                        <!--<el-image src="static/image/shijian.png" class="box-image"></el-image>-->
                        <!--<div class="box-div">{{gun.runtimeDay}} 天</div>-->
                        <!--</el-col>-->
                        <!--</el-tooltip>-->
                      </el-row>
                      <!--<template v-if="gun.status.value == 'charge_fault'">
                        <el-row>
                          <el-tooltip class="item" effect="dark" content="故障原因" placement="top-start">
                            <el-col :span="24">
                              <el-image src="static/image/guzhang.png" class="box-image"></el-image>
                              <div class="box-div">2019年6月27日 17:20:31<br/>机器故障-下雨进水了</div>
                            </el-col>
                          </el-tooltip>
                        </el-row>
                      </template>-->
                    </el-card>
                    <template v-if="gun.status.value == 'charging'">
                      <el-popover
                        placement="top"
                        width="250"
                        popper-class="port-detail-popover"
                        trigger="hover">
                        <div class="port-detail-div">
                          <el-row>
                            <el-image src="static/image/zhan.png" class="box-image"></el-image>
                            <div class="box-div">站名称：{{currentStationName}}</div>
                          </el-row>
                          <el-row>
                            <el-image src="static/image/number.png" class="box-image"></el-image>
                            <div class="box-div">枪号：{{gun.gunNumber}}</div>
                          </el-row>
                          <!--<el-row>-->
                          <!--<el-image src="static/image/shijian.png" class="box-image"></el-image>-->
                          <!--<div class="box-div">运行天数：{{gun.runtimeDay}}天</div>-->
                          <!--</el-row>-->
                          <el-row>
                            <el-image src="static/image/dianliang.png" class="box-image"></el-image>
                            <div class="box-div">电池情况</div>
                          </el-row>
                          <el-row>
                            <div class="box-div box-div-index">充电量：{{gun.totalPower}} kW·h</div>
                          </el-row>
                          <el-row>
                            <div class="box-div box-div-index">充电金额：{{gun.fee}} 元</div>
                          </el-row>
                          <el-row>
                            <div class="box-div box-div-index">充电时长：{{chargeTime(gun.totalTime)}}</div>
                          </el-row>
                          <el-row>
                            <div class="box-div box-div-index">电压：{{gun.voltage}} V</div>
                          </el-row>
                          <el-row>
                            <div class="box-div box-div-index">电流： {{gun.current}} A</div>
                          </el-row>
                          <el-row>
                            <div class="box-div box-div-index">功率：{{gun.power}} kw</div>
                          </el-row>
                          <el-row>
                            <el-image src="static/image/huiyuan.png" class="box-image"></el-image>
                            <div class="box-div">会员信息</div>
                          </el-row>
                          <el-row v-if="gun.startWay && gun.startWay == '1'" >
                            <div class="box-div box-div-index">电话：{{gun.phone}}</div>
                          </el-row>
                          <el-row v-if="gun.startWay && gun.startWay == '0'" >
                            <div class="box-div box-div-index">卡号：{{gun.cardNumber}}</div>
                          </el-row>
                          <!--<el-row>-->
                          <!--<el-image src="static/image/cheliang.png" class="box-image"></el-image>-->
                          <!--<div class="box-div">车辆信息</div>-->
                          <!--</el-row>-->
                          <!--<el-row>-->
                          <!--<div class="box-div box-div-index">车牌号：{{gun.carNumber}}</div>-->
                          <!--</el-row>-->
                          <!--<el-row>-->
                          <!--<div class="box-div box-div-index">品牌：{{gun.brand}}</div>-->
                          <!--</el-row>-->
                          <!--<el-row>-->
                          <!--<div class="box-div box-div-index">V I N：{{gun.vin}}</div>-->
                          <!--</el-row>-->
                        </div>
                        <span slot="reference" class="el-icon-arrow-down"></span>
                      </el-popover>
                    </template>
                    <template v-else>
                      <el-icon class="el-icon-arrow-down"></el-icon>
                    </template>

                    <template v-if="gun.modules.length > 0">
                      <el-popover
                        placement="top"
                        width="250"
                        popper-class="port-detail-popover"
                        trigger="hover">
                        <div class="port-detail-div">
                          <el-row>
                            <el-image src="static/image/zhan.png" class="box-image"></el-image>
                            <div class="box-div">站名称：{{currentStationName}}</div>
                          </el-row>
                          <el-row>
                            <el-image src="static/image/number.png" class="box-image"></el-image>
                            <div class="box-div">桩编号：{{gun.pileCode}}</div>
                          </el-row>
                          <el-row>
                            <el-image src="static/image/dianliang.png" class="box-image"></el-image>
                            <div class="box-div">模块信息</div>
                          </el-row>
                          <template v-for="(module, index) in gun.modules">
                            <el-row>
                              <div class="box-div box-div-index">第{{module.moduleNo}}个模块</div>
                            </el-row>
                            <el-row>
                              <div class="box-div box-div-index">编号：{{module.identification}}</div>
                            </el-row>
                            <el-row>
                              <div class="box-div box-div-index">电压：{{Math.round(module.voltage*10)/ 100}}V</div>
                            </el-row>
                            <el-row>
                              <div class="box-div box-div-index">电流：{{Math.round(module.current*10)/ 100}}A</div>
                            </el-row>
                            <el-row>
                              <div class="box-div box-div-index">状态： {{module.statusFlag}}</div>
                            </el-row>
                          </template>
                        </div>
                        <span slot="reference" class="el-icon-arrow-down"></span>
                      </el-popover>
                    </template>
                  </el-card>
                </div>
              </template>

            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </section>
</template>
<script>
  import * as api from '../api/chargingMonitor'

  export default {
    data() {
      return {
        tagSelecteds:[],
        timerTask: '',
        currentStationName: '',
        items: {
          all: {
            name: 'all',
            color: '#1cbbb4',
            bgColor: '#d2f1f0',
            label: '全部:',
            value: 0
          },
          charging: {
            name: 'charging',
            color: '#0081ff',
            bgColor: '#cce6ff',
            label: '充电:',
            value: 0
          },
          busy: {
            name: 'busy',
            color: '#f37b1d',
            bgColor: '#fde6d2',
            label: '占用:',
            value: 0
          },
          charge_appoint: {
            name: 'charge_appoint',
            color: '#fbbd08',
            bgColor: '#fef2ced2',
            label: '预约:',
            value: 0
          },
          free: {
            name: 'free',
            color: '#39b54a',
            bgColor: '#d7f0db',
            label: '空闲:',
            value: 0
          },
          charge_fault: {
            name: 'charge_fault',
            color: '#8799a3',
            bgColor: '#e7ebed',
            label: '故障:',
            value: 0
          },
          offline: {
            name: 'offline',
            color: '#e54d42',
            bgColor: '#fadbd9',
            label: '离线:',
            value: 0
          },
          // { color: '字体颜色', bgColor: '背景颜色', label: '显示内容', value: 数量 },
        },
        visibleArrow: false,
        stationNameIpt: '',
        stations: [], // 原始数据
        guns: [],
        tarGuns: [],
        stationTree: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    computed: {
      tagSelected: function() {
        return function(tagName){ // 判断当前标签是否已经选中
          if(this.tagSelecteds.indexOf(tagName) !== -1){
            return true
          }else {
            return false
          }
        }
      },
      showGun: function() {
        return function(tagName) { // 判断枪的状态是否在已经选择的状态列表中，并进行展示
          if(this.tagSelecteds && this.tagSelecteds.length !== 0) {
            if(this.tagSelecteds.indexOf(tagName) !== -1){
              return true
            }
            return false
          }else {
            return true
          }
        }
      },
      startType: function () {
        return function (startType) {
          if (startType === "0") {
            return '刷卡启动'
          } else if (startType === "1") {
            return '扫码启动'
          } else {
            return '未启动'
          }
        }
      },
      chargeTime: function () {
        return function (totalTime) {
          if (totalTime < 60) {
            return totalTime + '秒'
          }
          let chargeMin = Math.floor(totalTime / 60)
          let chargeSecond = totalTime % 60
          if (chargeMin < 60) {
            return chargeMin + '分' + chargeSecond + '秒'
          } else {
            let chargeHour = Math.floor(chargeMin / 60)
            chargeMin = chargeMin % 60
            return chargeHour + '时' + chargeMin + '分'
          }
        }
      },
      gunType: function () {
        // let testNull = {
        //   test1: null
        // }
        // console.log(testNull.test/100)
        return function (gunType) {
          console.log("gunType:"+gunType);
          if (gunType === 'S') {
            return '交流'
          } else if(gunType === 'F'){
            return '直流'
          }else{
            return '未知'
          }
        }
      }
    },
    watch: {
      stationNameIpt(val) {
        this.$refs.tree.filter(val);
      }
    },
    created() {
      console.log("获取站点信息")
      let that = this
      //获取数据
      let operatorIds = this.$store.getters.operatorIds
      console.log("从vuex中拿运营商编号：", operatorIds)
      if (operatorIds && operatorIds.length > 0) {
        // 普通有多个运营商的
        console.log(operatorIds)
        // 没有运营商的管理员？
      } else {
        operatorIds = []
      }

      console.log("运营商编号：", operatorIds)
      api.getStations(operatorIds).then((res) => {
        console.log(res)
        if (res.code === 0) {
          that.stations = res.data
          this.transformData(that.stations)
        }
      }).catch(() => {

      })
    },
    beforeDestroy() {
      console.log('页面卸载')
      clearInterval(this.timerTask);
    },
    methods: {
      inTimeDataTimerTask(stationId, stationName) { // 定时请求实时终端任务
        clearInterval(this.timerTask)
        this.currentStationName = stationName
        this.getGunsInfo(stationId)
        var timerTask = setInterval(() => {
          this.getGunsInfo(stationId)
        }, 3000)
        this.timerTask = timerTask
      },
      getGunsInfo(stationId) {
        // 发出请求
        //console.log("获取终端信息:", stationId)
        let that = this
        let params = stationId;
        api.getGunsInfo(params).then((res) => {
          //console.log(res)
          if (res.code === 0 && res.data) {
            that.guns = []
            //console.log("重置标签")
            for (let i in that.items) {
              that.items[i].value = 0
            }
            for (let i = 0; i < res.data.length; i++) {
              let gun = {};
              let modules = [];
              let gunType = res.data[i].pile.fastOrSlowCode;
              gun.gunType = gunType;
              console.log(gunType)
              let voltage, current, chargePower;
              /*if (gunType == null) {
                voltage = 0
                current = 0
                chargePower = 0
              } else if (gunType === 2) {
                voltage = this.isNullReplace(res.data[i].cmd104.AC_VA, 0) / 10
                current = this.isNullReplace(res.data[i].cmd104.AC_IA, 0) / 10
                chargePower = Math.floor(voltage * current / 10) / 100
              } else {*/
              //}

              voltage = Math.round(this.isNullReplace(res.data[i].cmd104.dcV, 0)*10)/ 100;
              current = Math.round(this.isNullReplace(res.data[i].cmd104.dcI, 0)*10)/ 100;
              if(!res.data[i].cmd104.chargePower || res.data[i].cmd104.chargePower === 0){
                chargePower = Math.round(voltage * current / 10) / 100
              }else{
                chargePower = this.isNullReplace(res.data[i].cmd104.chargePower, 0) / 10;
              }
              gun.voltage = voltage;
              gun.current = current;
              gun.power = chargePower;
              gun.totalPower = Math.round(this.isNullReplace(res.data[i].cmd104.chargeQuantity)) / 1000;// 充电量
              gun.fee = Math.round(this.isNullReplace(res.data[i].cmd104.fee, 0)) / 100; // 当前金额
              gun.soc = this.isNullReplace(res.data[i].cmd104.currentSOC, 0); // soc
              gun.gunNumber = res.data[i].gun.gunNum // 几号枪
              gun.gunCode = res.data[i].gun.gunCode // 枪编号
              gun.pileCode = res.data[i].pile.pileCode //桩编号
              gun.phone = this.isNullReplace(res.data[i].gun.phone,'无') // 手机
              gun.cardNumber = this.isNullReplace(res.data[i].gun.cardNo,'无') // 卡号
              gun.temperature = this.isNullReplace(res.data[i].cmd104.gunTemperature, '无') // 枪温度
              gun.totalTime = this.isNullReplace(res.data[i].cmd104.chargeTime, 0) // 充电时长
              gun.status = that.statusTranslate(res.data[i])  // 空闲状态等的类型
              gun.startWay = res.data[i].gun.startType // 开启充电方式
              gun.runtimeDay = '99'
              gun.modules = res.data[i].moduleInfo
              that.guns = [...that.guns, gun]
            }
            that.sortGuns()
          }
        }).catch(() => {
          console.log("枪详情加载出错")
        })
      },
      sortGuns() { // 桶排序
        let guns = this.guns
        let tags = Object.keys(this.items) // tags数组-按照这个顺序排序
        let tagGuns = []
        for(let i = 0;i < tags.length;i++) { // 初始化桶
          tagGuns[tags[i]] = []
        }
        for(let i = 0;i < guns.length;i++) { // 存入不同的桶中
          console.log(guns[i].status.value)
          tagGuns[guns[i].status.value].push(guns[i])
        }
        // 将二维组合成一维，输出
        let tarGuns = []
        for(let item in tagGuns) {
          tarGuns = [...tarGuns, ...tagGuns[item]]
        }
        console.log(tarGuns)
        this.tarGuns = tarGuns
      },
      statusTranslate(data) {
        //console.log(data)
        this.items.all.value += 1 // 全部
        let value
        let message
        if (!data.gun.gunConnectionState || data.gun.gunConnectionState.code == 0) {
          // console.log(data.gun.gunConnectionState.code)
          this.items.offline.value += 1 // 离线
          return {
            code: '0',
            value: 'offline',
            message: '离线'
          }
        }
        if (data.gun.state) {
          switch (data.gun.state.code) {
            case 0:
              this.items.free.value += 1 // 空闲
              value = 'free'
              message = '空闲'
              break
            case 2:
              this.items.charging.value += 1 // 正在充电中
              value = 'charging'
              message = '正在充电'
              break
            case 5:
              this.items.charge_appoint.value += 1 // 预约
              value = 'charge_appoint'
              message = '预约'
              break
            case 6:
              this.items.charge_fault.value += 1 // 故障
              value = 'charge_fault'
              message = '故障'
              break
            default:
              this.items.busy.value += 1 // 占用
              value = 'busy'
              message = '占用'
          }
          return {
            code: data.gun.state.code,
            value: value,
            message: message
          }
        } else {
          return {
            code: 0,
            value: 'free',
            message: '空闲'
          }
        }
      },
      transformData(stations) { // 转化原始数据
        let origins = stations
        let targets = []
        let provinceList = []
        let cityLists = []
        // let regionList = []
        let index, index2
        for (let i = 0; i < origins.length; i++) {
          if (origins[i].province) {
            if ((index = provinceList.indexOf(origins[i].province)) !== -1) { // 判断省是否存在
              // 省存在
              // console.log("省存在")
              if (origins[i].city) {
                if ((index2 = cityLists[index].indexOf(origins[i].city)) !== -1) { // 判断市是否存在
                  // 市存在
                  // console.log("市存在")
                  // console.log(origins[i].stationName)
                  let target = {
                    id: origins[i].id,
                    label: origins[i].stationName
                  }
                  targets[index].children[index2].children = [...targets[index].children[index2].children, target]
                } else { //市不存在
                  // console.log("市不存在")
                  // console.log(origins[i].stationName)
                  let target = {
                    id: origins[i].city,
                    label: origins[i].city,
                    children: [
                      {
                        id: origins[i].id,
                        label: origins[i].stationName,
                      }
                    ]
                  }
                  targets[index].children = [...targets[index].children, target]
                  cityLists[index] = [...cityLists[index], origins[i].city]
                }
              }
            } else { // 省不存在，从省开始添加数据
              // console.log("省不存在, 从省开始添加数据")
              // console.log(origins[i].stationName)
              let target = {
                id: origins[i].province,
                label: origins[i].province,
                children: [
                  {
                    id: origins[i].city,
                    label: origins[i].city,
                    children: [
                      {
                        id: origins[i].id,
                        label: origins[i].stationName,
                      }
                    ]
                  }
                ]
              }
              provinceList = [...provinceList, origins[i].province] // 添加省到省列表
              cityLists = [...cityLists, [origins[i].city]]  // 添加市到市列表
              targets = [...targets, target] // 添加数据
            }
          }
          // if(origins[i].city) {
          //   if((index = regionList.indexOf(origins[i].city)) !== -1) {
          //     targets[index].data = [...targets[index].data, origins[i]]
          //   }else {
          //     let target = {
          //       region: origins[i].city,
          //       data: [origins[i]]
          //     }
          //     regionList = [...regionList, origins[i].city]
          //     targets = [...targets, target]
          //   }
          // }
        }
        console.log(provinceList)
        console.log(cityLists)
        console.log("转化后的树结构数据：", targets)
        // this.regionList = regionList
        this.stationTree = targets
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      nodeClick(data, node, cmp) {
        if (node.isLeaf && node.isCurrent) {
          this.inTimeDataTimerTask(data.id, data.label)
          console.log("加载数据")
        }
      },
      ellipsis(value, length) {
        if (!value) return "";
        if (value.length > length) {
          return value.slice(0, length) + "...";
        }
        return value;
      },
      isNullReplace(data, rep) {
        if (data == null || data ==='') {
          return rep
        } else {
          return data
        }
      },
      switchTag(tagName) {
        if(tagName !== 'all') {
          let index = this.tagSelecteds.indexOf(tagName)
          if(index !== -1) { // 已选择
            this.tagSelecteds.splice(index,1)
          }else {
            this.tagSelecteds.push(tagName)
          }
        }
      }
    },
    mounted() {

    }
  }
</script>
<style scoped lang="less">
  .tree-aside {
  }

  .station-tree {
    margin-top: 10px;
    font-size: 14px;

    .box-image {
      width: 18px;
      height: 18px;
    }
  }

  tag-group__title {
    margin-left: 0px;
  }

  .el-tag + .el-tag {
    margin-left: 30px;
  }

  .my-autocomplete {
    li {
      line-height: normal;
      padding: 0px;
    }
  }

  .all-port-div {
    text-align: left;

    .port-div {
      font-size: 11px;
      text-align: center;
      min-width: 320px;
      display: inline-block;
      margin: 10px 0 0 10px;

      .box-card {
        /deep/ .el-card__body {
          padding: 10px 10px 0 10px;

          .box {
            text-align: left;
            margin-top: 10px;
            color: #8c939d;

            .box-image {
              vertical-align: middle;
              width: 20px;
              height: 20px;
            }

            .box-div {
              vertical-align: middle;
              display: inline-block;
            }
          }

          .el-tag {
            min-width: 80%;
            /*color: #8c939d;*/
            /*background-color: #ffffff;*/
            /*border-color: #8c939d;*/
          }
        }
      }
    }
  }

  .port-detail-popover {
    .port-detail-div {
      text-align: left;
      margin-top: 10px;
      color: #8c939d;
      font-size: 11px;

      .el-row {
        margin-bottom: 4px;
      }

      .box-image {
        vertical-align: middle;
        width: 20px;
        height: 20px;
      }

      .box-div {
        vertical-align: middle;
        display: inline-block;
      }

      .box-div-index {
        margin-left: 24px;
      }
    }
  }

  .bg-purple {
    background: #d3dce6;
  }

  .gun-state {
    height: 34px;
    line-height: 34px;
    font-size: small;
    color: #606266;
    text-align: center;
  }

  .el-row {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 10px;
    }
  }

  .bg-purple {
    background: #d3dce6;
  }

  .grid-content-box {
    border-radius: 4px;
    background: linear-gradient(#007cff, #3397ff, #80beff);
    height: 58px;
    color: #EBEEF5;
    line-height: 58px;
    font-size: 16px;
    box-shadow: 1px 1px 6px #909399;
  }

  .has-no-paddingtop {
    padding-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/chargingMonitor.vue